export default{
  namespaced: true,
  state:{
    tasks: []
  },
  getters : {},
  mutations:{
    ADD_TASKS_TO_LIST(state,data){
      state.tasks = data
    }
  }
}